<template>
  <div class="login-view" :class="configStore.electronMode ? 'white-backgroup' : ''">
    <div class="decoration decoration-1"></div>
    <div class="decoration decoration-2"></div>
    <div class="decoration decoration-3"></div>
    <div class="content">
      <!-- 密码登录表单 -->
      <el-form
        v-if="loginMode === 'password'"
        class="form"
        :model="loginForm"
        status-icon
        :rules="rules"
        ref="loginForm"
        @keyup.enter.native="submitForm()"
        v-loading="loading"
        element-loading-text="正在登陆..."
      >
        <div class="title">登录球聊</div>
        <el-form-item prop="terminal" v-show="false">
          <el-input type="terminal" v-model="loginForm.terminal"></el-input>
        </el-form-item>
        <el-form-item prop="userName">
          <el-input
            type="userName"
            v-model="loginForm.userName"
            :placeholder="loginNamePlaceholder"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="nav-tool-bar">
            <el-checkbox v-model="isAutoLogin">下次自动登录</el-checkbox>
            <router-link v-if="containsPhoneMode || containsEmailMode" class="forgot-pwd" to="/password/reset"
              >忘记密码?</router-link
            >
          </div>
        </el-form-item>
        <el-button class="submit-btn" type="primary" @click="submitForm()">登录</el-button>
        <div class="qr-switch-btn" type="success" @click="toggleLoginMode">
          <i class="iconfont icon-scan"></i>
          扫码登录
        </div>
        <div class="register">
          <router-link to="/register">没有账号? 立即注册</router-link>
        </div>
      </el-form>

      <!-- 扫码登录界面 -->
      <QrLogin v-if="loginMode === 'qr'" @back="goBackToPassword" />
    </div>
    <icp></icp>
    <captcha-image ref="captchaRef"></captcha-image>
  </div>
</template>

<script>
import Icp from '../components/common/Icp.vue';
import CaptchaImage from '../components/common/CaptchaImage.vue';
import QrLogin from '../components/login/QrLogin.vue';

export default {
  name: 'login',
  components: {
    Icp,
    CaptchaImage,
    QrLogin,
  },
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'));
      }
      callback();
    };
    var checkPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      callback();
    };
    return {
      loading: false,
      isAutoLogin: true,
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        userName: '',
        password: '',
        platform: 1,
      },
      rules: {
        userName: [
          {
            validator: checkUsername,
            trigger: 'blur',
          },
        ],
        password: [
          {
            validator: checkPassword,
            trigger: 'blur',
          },
        ],
      },
      // 登录模式切换
      loginMode: 'password', // password, qr
    };
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: '/login',
            method: 'post',
            data: this.loginForm,
          })
            .then((data) => {
              localStorage.setItem('isAutoLogin', this.isAutoLogin);
              // 保存密码到
              localStorage.setItem('username', this.loginForm.userName);
              localStorage.setItem('password', this.loginForm.password);
              // localStorage
              sessionStorage.setItem('accessToken', data.accessToken);
              sessionStorage.setItem('refreshToken', data.refreshToken);
              this.$message.success('登录成功');
              this.$router.push('/home/chat');
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取cookie、
    getCookie(name) {
      let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
      let arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      }
      return '';
    },
    // 设置cookie,增加到vue实例方便全局调用
    setCookie(name, value) {
      document.cookie = name + '=' + escape(value);
    },
    // 登录模式切换
    toggleLoginMode() {
      if (this.loginMode === 'password') {
        this.loginMode = 'qr';
      } else {
        this.loginMode = 'password';
      }
    },
    goBackToPassword() {
      this.loginMode = 'password';
    },
  },
  mounted() {
    // 账号密码
    this.loginForm.userName = localStorage.getItem('username');
    this.loginForm.password = localStorage.getItem('password');
    // 加载配置
    this.configStore.loadConfig();
    // electron 窗口大小
    window.electronAPI &&
      window.electronAPI.sendEvent('resize', {
        width: 410,
        height: 510,
        maximizable: false,
      });
    // 自动登录
    if (localStorage.getItem('isAutoLogin') != null) {
      this.isAutoLogin = JSON.parse(localStorage.getItem('isAutoLogin'));
      if (this.isAutoLogin) {
        this.submitForm();
      }
    }
  },
  computed: {
    loginNamePlaceholder() {
      let mode = this.configStore.registration.mode;
      let strText = '用户名';
      if (mode.includes('phone')) {
        strText += '/手机号';
      }
      if (mode.includes('email')) {
        strText += '/邮箱';
      }
      return strText;
    },
    containsPhoneMode() {
      return this.modes.includes('phone');
    },
    containsEmailMode() {
      return this.modes.includes('email');
    },
    modes() {
      return this.configStore.registration.mode || [];
    },
  },
};
</script>

<style scoped lang="scss">
.login-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  position: relative;
  // dawn 底纸 (覆盖 body 同一励色调 + 有微差别的柔光)
  background:
    radial-gradient(120% 80% at 0% 100%, rgba(255, 230, 130, 0.36) 0%, transparent 50%),
    radial-gradient(80% 60% at 100% 0%, rgba(255, 200, 220, 0.24) 0%, transparent 60%),
    radial-gradient(60% 50% at 50% 100%, rgba(168, 139, 255, 0.10) 0%, transparent 70%),
    linear-gradient(180deg, var(--codex-cream-4) 0%, var(--codex-cream-1) 40%, var(--codex-cream-2) 100%);

  &.white-backgroup {
    background: white;
  }

  /* Aurora 光环 (漂浮装饰) */
  .decoration {
    position: absolute;
    border-radius: 50%;
    filter: blur(40px);
    pointer-events: none;
  }

  .decoration-1 {
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, rgba(91, 141, 238, 0.32), transparent 70%);
    top: -100px;
    right: -40px;
    animation: float 16s infinite ease-in-out;
  }

  .decoration-2 {
    width: 280px;
    height: 280px;
    background: radial-gradient(circle, rgba(168, 139, 255, 0.28), transparent 70%);
    bottom: -120px;
    left: -60px;
    animation: float 12s infinite ease-in-out;
  }

  .decoration-3 {
    width: 160px;
    height: 160px;
    background: radial-gradient(circle, rgba(255, 175, 204, 0.30), transparent 70%);
    top: 50%;
    right: 40px;
    animation: float 8s infinite ease-in-out;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0) translateX(0);
    }

    25% {
      transform: translateY(-60px) translateX(30px);
    }

    50% {
      transform: translateY(30px) translateX(-45px);
    }

    75% {
      transform: translateY(-30px) translateX(-30px);
    }
  }

  .content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .form {
      width: 380px;
      padding: 32px 28px;
      // glass-l2 消息卡片
      background: rgba(255, 252, 243, 0.78);
      backdrop-filter: blur(40px) saturate(160%);
      -webkit-backdrop-filter: blur(40px) saturate(160%);
      border: 0.5px solid rgba(255, 255, 255, 0.55);
      border-radius: var(--radius-xl);
      box-shadow:
        inset 0 1px 0 0 rgba(255, 255, 255, 0.9),
        0 4px 12px rgba(31, 31, 35, 0.08),
        0 24px 64px rgba(31, 31, 35, 0.14);
      overflow: hidden;
      position: relative;
      z-index: 1;

      // 顶部 Aurora 装饰线
      &::before {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0;
        height: 2px;
        background: linear-gradient(90deg,
          var(--aurora-blue) 0%,
          var(--aurora-purple) 35%,
          var(--aurora-pink) 65%,
          var(--aurora-gold) 100%);
        opacity: 0.7;
      }

      ::v-deep .el-form-item {
        margin-bottom: 16px;

        .el-input__inner {
          height: 48px;
          line-height: 48px;
          border-radius: var(--radius-md);
          border: 0.5px solid var(--hairline-mid);
          background: rgba(255, 255, 255, 0.55);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.85);
          transition: all 0.24s ease;
          padding-left: 44px;
          font-size: var(--im-font-size-large);
          letter-spacing: -0.2px;
          color: var(--im-text-color);

          &:hover {
            border-color: var(--hairline-strong);
            background: rgba(255, 255, 255, 0.7);
          }

          &:focus {
            border-color: var(--aurora-blue);
            background: rgba(255, 255, 255, 0.92);
            box-shadow:
              inset 0 1px 0 0 rgba(255, 255, 255, 0.85),
              0 0 0 3px rgba(91, 141, 238, 0.18);
          }

          &::placeholder {
            color: var(--im-text-color-lighter);
            font-size: var(--im-font-size);
          }
        }

        .el-input__prefix {
          left: 14px;

          .el-input__icon {
            color: var(--aurora-blue);
            font-size: 18px;
            line-height: 48px;
          }
        }

        .el-input__suffix {
          display: none;
        }
      }

      .title {
        line-height: 50px;
        margin: 8px 0 24px;
        font-size: 26px;
        font-weight: 700;
        letter-spacing: -0.6px;
        text-align: center;
        // Aurora 渐变文字
        background: linear-gradient(135deg, var(--aurora-blue) 0%, var(--aurora-purple) 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .submit-btn {
        width: 100%;
        height: 46px;
        border-radius: var(--radius-md);
        border: none;
        background: linear-gradient(135deg, var(--aurora-blue) 0%, var(--aurora-purple) 100%);
        color: white;
        font-size: var(--im-font-size-large);
        font-weight: 600;
        letter-spacing: 4px;
        box-shadow:
          inset 0 1px 0 0 rgba(255, 255, 255, 0.30),
          0 4px 12px rgba(91, 141, 238, 0.32);
        transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 10px 24px rgba(91, 141, 238, 0.40);
        }
        &:active { transform: scale(0.98); }
      }

      .qr-switch-btn {
        width: 100%;
        margin-top: 12px;
        height: 46px;
        border-radius: var(--radius-md);
        border: 0.5px solid rgba(91, 141, 238, 0.35);
        background: rgba(91, 141, 238, 0.06);
        color: var(--aurora-blue);
        font-size: var(--im-font-size-large);
        font-weight: 600;
        transition: all 0.24s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
          background: linear-gradient(135deg, var(--aurora-blue), var(--aurora-purple));
          color: white;
          transform: translateY(-1px);
          border-color: transparent;
          box-shadow: 0 8px 20px rgba(91, 141, 238, 0.32);
        }

        i { margin-right: 8px; font-size: 18px; }
      }

      .nav-tool-bar {
        display: flex;
        justify-content: space-between;

        .forgot-pwd {
          text-decoration: none;
          color: var(--im-text-color-secondary);
          font-size: var(--im-font-size-small);
          transition: color 0.2s ease;

          &:hover { color: var(--aurora-blue); }
        }
      }

      .register {
        display: flex;
        flex-direction: row-reverse;
        line-height: 40px;
        text-align: left;
        margin-top: 12px;

        a {
          color: var(--im-text-color-secondary);
          text-decoration: none;
          font-size: var(--im-font-size);
          transition: color 0.2s ease;

          &:hover { color: var(--aurora-blue); }
        }
      }
    }
  }
}
</style>
